import { render, staticRenderFns } from "./StudyManagement.vue?vue&type=template&id=83ca560a&lang=pug"
import script from "./StudyManagement.vue?vue&type=script&lang=ts"
export * from "./StudyManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports